import React from 'react'
import PropTypes from 'prop-types'
import { Container, Month } from './styled'
import FlexHorizontalDrag from '@/components/Draggers/FlexHorizontalDrag'

interface Props {
  variant: string
  setMonth: (month: string) => void
  selectedMonth: string
  months: Array<string>
}

const FormMonths: React.FC<Props> = React.forwardRef(
  ({ variant, months, setMonth, selectedMonth }, ref) => (
    <Container ref={ref}>
      <FlexHorizontalDrag parentRef={ref}>
        <>
          {months.map((monthName) => {
            let vari = variant
            if (selectedMonth === monthName) {
              vari += 'Ac'
            } else {
              vari += 'In'
            }

            return (
              <Month
                data-url
                key={monthName}
                variant={vari}
                onPointerDown={() => setMonth(monthName)}
              >
                {monthName}
              </Month>
            )
          })}
        </>
      </FlexHorizontalDrag>
    </Container>
  ),
)

FormMonths.defaultProps = {
  variant: 'light',
  selectedMonth: null,
}

FormMonths.propTypes = {
  selectedMonth: PropTypes.string,
  setMonth: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['dark', 'light']),
}

export default FormMonths
